import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translation/en.json';
import ru from './translation/ru.json';
import es from './translation/es.json';

const resources = {	en, ru, es};

i18n.use( initReactI18next ).init( {
	resources,
	lng: 'ru',
	interpolation: {
		escapeValue: false
	}
} );

export default i18n;
